module.exports = __webpack_public_path__ + "static/media/ESS_cylinder.8c9b4d64.jpg";